import React, { useMemo } from "react"
import { Card, Chip, Grid2 as Grid, Typography } from "@mui/material"
import { filterArray } from "../../../../helpers/arrayHelper"

export const ProfileInterests = (props) => {
  const {
    titleProps,
    title,
    interests,
    sfwKey,
    nsfwKey,
    hideCard = false,
    minHeight = '176px',
    isArrayOfObjects = true,
    sfwList = [],
    nsfwList = [],
    customTitle

  } = props;

  const subTitleProps = { variant: "h3", fontWeight: 700, color: "primary.main", mb: 1, fontSize: '1rem' };

  const chipProps = {
    variant: "outlined",
    color: "primary",
    sx: {
      mr: 0.8, mb: 0.8
    }
  }

  const renderInterests = useMemo(() => {
    return {
      sfw: filterArray(interests, sfwKey, 'type') ?? [],
      nsfw: filterArray(interests, nsfwKey, 'type') ?? [],
    }
  }, [interests])

  return (
    <Card sx={{
      minHeight: { xs: 'auto', md: minHeight },
      ...(hideCard && {
        padding: '0px',
        background: 'transparent',
        borderRadius: '0px'
      })
    }}>
      {customTitle ?? <Typography {...titleProps}>{title}</Typography>}
      <Grid container spacing={3}>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Typography {...subTitleProps}>SFW</Typography>
          {
            isArrayOfObjects ? renderInterests?.sfw?.map((item, index) => {
              return (
                <Chip key={`collab-sfw-object-key-${index}`} label={item?.name} {...chipProps} />
              )
            }) : Object.values(sfwList)?.map((item, index) => {
              return (
                <Chip key={`collab-sfw-key-${index}`} label={item} {...chipProps} />
              )
            })
          }
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Typography {...subTitleProps}>NSFW</Typography>
          {
            isArrayOfObjects ? renderInterests?.nsfw?.map((item, index) => {
              return (
                <Chip key={`collab-nsfw-object-key-${index}`} label={item?.name} {...chipProps} />
              )
            }) : Object.values(nsfwList)?.map((item, index) => {
              return (
                <Chip key={`collab-nsfw-key-${index}`} label={item} {...chipProps} />
              )
            })
          }
        </Grid>
      </Grid>
    </Card>
  )
};